import { useMemo } from "react"
import { useSelector } from "react-redux"

import ServicesItem from "./ServicesItem"

import classes from '../Shared/Container.module.css'

const ServicesDetails = ({drawerData, servicesEditDisabled}) => {
    let  activeCase = useSelector(state => state.case.activeCase)

    if (drawerData) {
        activeCase = drawerData
    }

    const searchedServicesResult = useSelector(state => state.services.filterResult)


    const displayedServices = useMemo(() => {
        const source = !searchedServicesResult ? activeCase?.services : searchedServicesResult
        if (!source) return []
        return [...source].sort((a, b) => new Date(b.date_ordered) - new Date(a.date_ordered))
    }, [activeCase?.services, searchedServicesResult])

    return <div className={`${classes.container} ${classes.container_padding}`}>
        {activeCase && activeCase.services && <>
            <table>
                <thead>
                    <tr>
                        <th className="table-cell-fit">Date Ordered</th>
                        <th>Ordered by</th>
                        <th>Class</th>
                        <th style={{width: 200}}>Area/Description</th>
                        {/* <th>Diagnosis</th> */}
                        <th>Outside</th>
                        <th>Clinic</th>
                        <th>Provider</th>
                        <th className="table-cell-fit">Completed date</th>
                    </tr>
                </thead>
                <tbody>
                        {!searchedServicesResult && displayedServices.map(serviceItem => (
                            <ServicesItem
                                key={serviceItem.id}
                                itemData={serviceItem}
                                surgeries={activeCase.surgeries}
                                servicesEditDisabled={servicesEditDisabled}
                            />
                        ))}
                        {searchedServicesResult && searchedServicesResult.length > 0 && displayedServices.map(serviceItem => (
                            <ServicesItem
                                key={serviceItem.id}
                                itemData={serviceItem}
                                surgeries={activeCase.surgeries}
                                servicesEditDisabled={servicesEditDisabled}
                            />
                        ))}
                        {searchedServicesResult && searchedServicesResult.length == 0 && <tr>
                            <td colSpan="11">No results found!</td>
                        </tr>}
                </tbody>
            </table>
        </>}
    </div>
}

export default ServicesDetails